import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
  alpha,
  useTheme,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { DialogTitleWithClose } from "./DialogTitleWithClose";

export const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  color = "primary",
  isLoading = false,
}) => {
  const theme = useTheme();
  const themeColor = theme.palette[color]?.main || theme.palette.primary.main;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 3,
          p: 1,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitleWithClose
        component="div"
        onClose={onCancel}
        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
      >
        <Box
          sx={{
            display: "flex",
            p: 1,
            borderRadius: 1.5,
            bgcolor: alpha(themeColor, 0.1),
            color: `${color}.main`,
          }}
        >
          <WarningAmberIcon />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
      </DialogTitleWithClose>
      <DialogContent>
        <DialogContentText
          sx={{ color: "text.secondary", mt: 1, fontWeight: 500 }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onCancel}
          disabled={isLoading}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 1.5 }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          variant="contained"
          disableElevation
          color={color}
          autoFocus
          sx={{ borderRadius: 1.5 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
